module.exports = __webpack_public_path__ + "media/images/welcome-game-446a2b55bfc2526c6c3736d855cc2956.jpg";